import React from 'react'
import './create-note-modal-2023.css'
import { baseUrl } from '../../../assets/Animations'
import axios from 'axios'
import { MdClose } from 'react-icons/md'
import { getRequestHeaders } from '../../../api'
import ShortToggle from '../../../DanitComponents/Toggles/ShortToggle'

const CreateNoteModal2023 = ({
    setCreateNoteModal, 
    modalInfo,
    userData, 
    createAndAddNote, 
    editNote, 
    setEditNote,
    updateAndReplaceNote, 
    deleteAndRemoveNote,
    school
}) => {

    let newInitNote = {
        id: Math.random().toString(16).slice(2),
        date: new Date(),
        type: modalInfo.type,
        author: userData.Name,
        important: false,
        connections: [],
        details: "",
        applicationId: modalInfo.type === 'applicationId' ? modalInfo.id : '',
        invoiceId: modalInfo.type === 'invoiceId' ? modalInfo.id : '',
        onboardingId: modalInfo.type === 'onboardingId' ? modalInfo.id : '',
        familyId: modalInfo.type === 'familyId' ? modalInfo.id : '',
        tasksId: modalInfo.type === 'tasksId' ? modalInfo.id : '',
        teacherId: modalInfo.type === 'teacherId' ? modalInfo.id : '',
        timesheetId: modalInfo.type === 'timesheetId' ? modalInfo.id : '',
        workflowId: modalInfo.type === 'workflowId' ? modalInfo.id : '',
        miscId1: modalInfo.type === 'miscId1' ? modalInfo.id : '',
        miscId2: modalInfo.type === 'miscId2' ? modalInfo.id : '',
        miscId3: modalInfo.type === 'miscId3' ? modalInfo.id : '',
        miscId4: modalInfo.type === 'miscId4' ? modalInfo.id : '',
        miscId5: modalInfo.type === 'miscId5' ? modalInfo.id : '',
        miscId6: modalInfo.type === 'miscId6' ? modalInfo.id : '',
        miscId7: modalInfo.type === 'miscId7' ? modalInfo.id : '',
        miscId8: modalInfo.type === 'miscId8' ? modalInfo.id : '',
        miscId9: modalInfo.type === 'miscId9' ? modalInfo.id : '',
        miscId10: modalInfo.type === 'miscId10' ? modalInfo.id : '',
        displayName: modalInfo.displayName,
      }

      const SoloDropdown = ({value, onChange, options, connectionType}) => (
        <select style={value === '' ? {color: '#64748B'} : {color: '#3B82F6'}} className='create-note-modal-2023__solo-dropdown' onChange={(e) => onChange(e.target.value)} value={value}>
            <option value="">{value === '' ? `Connect ${connectionType}` : 'Remove Connection'}</option>
            {options.map((option) => <option key={option.id} value={option.id}>{option.label}</option>)}
        </select>
      )

    const [familyNameSuggestions, setFamilyNameSuggestions] = React.useState([])
    const [teacherNameSuggestions, setTeacherNameSuggestions] = React.useState([])
    const [note, setNote] = React.useState(editNote ? editNote : newInitNote)

      React.useEffect(() => {
        getListOfSchoolsTeachers()
        getListOfSchoolsFamilies()
      }, [])

      React.useEffect(() => {
        console.log(note.connections)
      }, [note])

    const closeAttempt = (target) => {
        if(target === 'create-note-modal-2023-wrapper' && editNote) {
            setEditNote(false)
        } else if(target === 'create-note-modal-2023-wrapper' && !editNote) {
            setCreateNoteModal(false)
        }
    }

    const sortAlphabetically = (array) => {
        array.sort((a, b) => {
            if(a.label < b.label) { return -1; }
            if(a.label > b.label) { return 1; }
            return 0;
        })
        return array
    }

    const getListOfSchoolsTeachers = () => {
        axios.get(`${baseUrl}/rawteacherdata/${school}`, getRequestHeaders())
        .then(res => {
            let fixedTeachers = [] 
            res.data.forEach(teacher => {fixedTeachers.push({id: teacher.TeacherID, label: teacher.Name})})
            setTeacherNameSuggestions(sortAlphabetically(fixedTeachers))
        })
        .catch(err => {
            console.log(err)
        })
    }

    const getListOfSchoolsFamilies = () => {
        axios.get(`${baseUrl}/school-management/school/${school.toUpperCase()}`, getRequestHeaders())
        .then(res => {
            let fixedFamilies = []
            res.data.forEach(family => {fixedFamilies.push({id: family.familyId, label: family.familyName})})
            setFamilyNameSuggestions(sortAlphabetically(fixedFamilies))
        })
        .catch(err => {
            console.log(err)
        })
    }

    const lookForExistingConnectionAndRemoveIt = (connectionType) => {
        let edittedConnections = note.connections
        for(let i = 0; i < edittedConnections.length; i++) {
            if(edittedConnections[i].type === connectionType) {
                edittedConnections.splice(i, 1)
            }
        }
        setNote({...note, connections: edittedConnections, [connectionType]: ''})
    }

    const createNewConnectionAndPushIt = (connectionType, id, displayName) => {
        let edittedConnections = note.connections
        edittedConnections.push({
            connectionId: Math.random().toString(16).slice(2),
            type: connectionType,
            id: id,
            displayName: displayName
        })
        setNote({...note, connections: edittedConnections, [connectionType]: id})
    }

    const findAndEditConnection = (connectionType, id, displayName) => {
        let edittedConnections = note.connections
        for(let i = 0; i < edittedConnections.length; i++) {
            if(edittedConnections[i].type === connectionType) {
                edittedConnections[i].id = id
                edittedConnections[i].displayName = displayName
            }
        }
        setNote({...note, connections: edittedConnections, [connectionType]: id})
    }

    const chooseTheFamily = (id) => {
        if(id === '') {
            lookForExistingConnectionAndRemoveIt('familyId')
            return
        }
        if(note.connections.length === 0) {
            createNewConnectionAndPushIt('familyId', id, familyNameSuggestions.find(family => family.id === id).label)
        } else {
            for(let i = 0; i < note.connections.length; i++) {
                if(note.connections[i].type === 'familyId') {
                    findAndEditConnection('familyId', id, familyNameSuggestions.find(family => family.id === id).label)
                    return
                } else {
                    createNewConnectionAndPushIt('familyId', id, familyNameSuggestions.find(family => family.id === id).label)
                }
            }
        }
    }

    const chooseTheTeacher = (id) => {
        if(id === '') {
            lookForExistingConnectionAndRemoveIt('teacherId')
            return
        }
        if(note.connections.length === 0) {
            createNewConnectionAndPushIt('teacherId', id, teacherNameSuggestions.find(teacher => teacher.id === id).label)
        } else {
            for(let i = 0; i < note.connections.length; i++) {
                if(note.connections[i].type === 'teacherId') {
                    findAndEditConnection('teacherId', id, teacherNameSuggestions.find(teacher => teacher.id === id).label)
                    return
                } else {
                    createNewConnectionAndPushIt('teacherId', id, teacherNameSuggestions.find(teacher => teacher.id === id).label)
                }
            }
        }
    }

    const writeNote = (text) => {
        setNote({...note, details: text})
    }

    return(
        <div className='create-note-modal-2023-wrapper' id='create-note-modal-2023-wrapper' onClick={(e) => closeAttempt(e.target.id)}>
            <div className='create-note-modal-2023-modal'>
                <div className='create-note-modal-2023-modal__close-x-wrapper'>
                    <MdClose className='create-note-modal-2023-modal__close-x' onClick={() => closeAttempt('create-note-modal-2023-wrapper')} color='rgb(148, 163, 184)' size={28}/>
                </div>
                <div className='create-note-modal-2023-modal__title'>Add a note</div>
                <div className='create-note-modal-2023-modal__connections-area__wrapper'>
                    <div className='create-note-modal-2023-modal__important-switch__wrapper'>
                        <div className='create-note-modal-2023-modal__important-label' style={note.important ? {color: 'red'} : {color: 'grey'}}>Important</div>
                        <ShortToggle value={note.important} onChange={() => setNote({...note, important: !note.important})} />
                    </div>
                    <SoloDropdown connectionType="Teacher" value={note.teacherId} onChange={chooseTheTeacher} options={teacherNameSuggestions} />
                    <SoloDropdown connectionType="Family" value={note.familyId} onChange={chooseTheFamily} options={familyNameSuggestions} />
                </div>
                <textarea className='create-note-modal-2023-modal__text-area' value={note.details} onChange={(e) => writeNote(e.target.value)} placeholder='Add notes here...' />
                {editNote ? <div className='create-note-modal-2023-modal__submit-btn' onClick={() => updateAndReplaceNote(note)}>Edit Event</div> : <div className='create-note-modal-2023-modal__submit-btn' onClick={() => createAndAddNote(note)}>Add note</div>}
            </div>
        </div>
    )
}
export default CreateNoteModal2023;